import { render, staticRenderFns } from "./Screen.vue?vue&type=template&id=9752ef22&scoped=true&"
import script from "./Screen.vue?vue&type=script&lang=js&"
export * from "./Screen.vue?vue&type=script&lang=js&"
import style0 from "./Screen.vue?vue&type=style&index=0&id=9752ef22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9752ef22",
  null
  
)

component.options.__file = "Screen.vue"
export default component.exports